'use client'

import { resolveLabel } from 'src/components/list/helpers/resolveLabel'
import { Pagination } from 'src/components/list/Pagination'
import OpenAccessSelect from 'src/components/open-access/list/OpenAccessSelect'
import { useTranslateEntry } from 'src/i18n/client/useTranslateEntry'

/**
 * Wspólny pasek sterowania listą: paginacja + sortowanie (+ opcjonalny element po lewej).
 *
 * Używaj tego komponentu we wszystkich listach, żeby zachować spójny wygląd i nie kopiować markup-u.
 * Najczęściej `leading` to tekst "Znaleziono: X wyników".
 */
export default function ListSortControls({
  page,
  totalPages,
  onPageChange,
  sortOptions = [],
  sortValue,
  onSortValueChange,
  leading = null,
  wrapperClassName = 'flex flex-col gap-16 d:flex-row d:items-center d:justify-between',
  controlsClassName = 'flex flex-col gap-16 d:flex-row d:items-center d:justify-between w-fit ml-auto mb-20',
  dividerClassName = 'hidden h-32 border-l border-dark-blue-dark-blue2 d:block',
  paginationVariant = 'open-access',
}) {
  const translateEntry = useTranslateEntry()
  const translatedSortOptions = sortOptions.map((option) => ({
    ...option,
    label: resolveLabel(translateEntry, option.labelKey, option.label),
  }))

  return (
    <div className={wrapperClassName}>
      {leading}

      <div className={controlsClassName}>
        <Pagination page={page} pages={totalPages} setPage={onPageChange} variant={paginationVariant} />

        <div className={dividerClassName} aria-hidden />

        <OpenAccessSelect
          options={translatedSortOptions}
          value={sortValue}
          onChange={(option) => onSortValueChange?.(option?.value)}
        />
      </div>
    </div>
  )
}
